import React from 'react';
import {ReactComponent as UserGroupIcon} from "@assets/icons/specialists.svg";
import AppButton from "@common/components/app-button";
import {ReactComponent as PlusIcon} from "@assets/icons/plus.svg";


const EmptySpecialistList: React.FC = () => {

    return (
        <span className="text-base text-on-surface/60 font-normal">
            Nie masz jeszcze zadnych specjalistów
        </span>
    );
};

export default EmptySpecialistList;
